import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import { customScrollStyles } from '@gem/ui-kit';

import styles from './LoginLayout.styles.m.css';
import { ILoginLayoutProps } from './LoginLayout.types';

export const LoginLayout: FC<PropsWithChildren<ILoginLayoutProps>> = (props) => {
  const {
    children,
    isDarkMode,
    backgroundSrc,
    className,
    contentClassName,
    scrollbarHidden,
    footer,
    mainWrapperClassName,
  } = props;

  const containerClassName = classNames(styles.container, className, {
    [styles.scrollbarHidden]: scrollbarHidden,
  });

  const mainClassName = classNames(styles.main, contentClassName);

  return (
    <div className={containerClassName}>
      <div className={classNames(styles.mainWrapper, mainWrapperClassName)}>
        <main className={mainClassName}>
          <div className={classNames(customScrollStyles.container, styles.scrollContainer)}>
            <div className={styles.wrapper}>
              <div className={styles.content}>{children}</div>
            </div>
          </div>
        </main>
        {!!footer && <footer>{footer}</footer>}
      </div>
      <img
        className={styles.background}
        alt=""
        src={isDarkMode ? backgroundSrc.dark : backgroundSrc.light}
      />
    </div>
  );
};
